import { ReactNode } from 'react'
import { useSelector } from 'react-redux'
import { EventScopeProvider, ProductEventEmitterBinding } from '@labrav/common'
import type { AppState } from '../../../store/reducer'

/**
 * Root event scope: the identity every product event carries. Lives inside the
 * Redux Provider because App itself renders above it. Product areas nest their
 * own EventScopeProvider under this one for product/section/route keys.
 */
export const AnalyticsIdentityScope = ({
  children,
}: {
  children: ReactNode
}) => {
  const { partnerId, partnerUserId, roles } = useSelector(
    (state: AppState) => state.authorization
  )

  return (
    <EventScopeProvider
      metadata={{
        partner_id: partnerId ?? undefined,
        partner_user_id: partnerUserId ?? undefined,
        user_role_key: roles[0]?.toLowerCase(),
      }}
    >
      <ProductEventEmitterBinding />
      {children}
    </EventScopeProvider>
  )
}
